<mbs-modal [title]="'shared:licenses.renewLicenseModal.title' | i18next"
           [isCustomModal]="true"
           [showFooter]="true"
           [titleTextOverflow]="true"
           [loading]="loading"
           #modal>
  <div modal-body>
    <span class="d-block mt-2">
      <ng-container *ngIf="!totalStorages">
        {{ 'shared:licenses.renewLicenseModal.youAreGoingToRenew' | i18next: { licenses: totalLicenses || 0, licensesCost:
          discountedPrice | pricePrepayment | async} }}
      </ng-container>

      <ng-container *ngIf="totalStorages">
        {{ 'shared:licenses.renewLicenseModal.youAreGoingToRenewWithStorages' | i18next: { licenses: totalLicenses || 0, licensesCost:
          discountedPrice | pricePrepayment | async, storages: totalStorages, storagesCost: storagesTotalCost | pricePrepayment | async} }}
      </ng-container>

    </span>

    <span class="d-block mt-2 mb-4">
      {{
        'shared:licenses.renewLicenseModal.totalAmount' | i18next: { money: totalAmount | pricePrepayment | async}
      }}
    </span>

    <ng-container *ngIf="isNotEnoughCreditsToPay && isPaymentLessThanOneDollar">
      <span class="d-block mt-2">{{ 'shared:licenses.renewLicenseModal.minimalPayment' | i18next: { money:
          1 }
        }}</span>
      <span class="d-block mt-2">{{
          'shared:licenses.renewLicenseModal.willBeReturnedToYourAccountInCredits' | i18next: { money: getTotalDiff() }
        }}</span>
    </ng-container>

    <ng-container *ngIf="isNotEnoughCreditsToPay && !isPaymentLessThanOneDollar && balanceValue">
      <span class="d-block mt-2">{{ 'shared:licenses.renewLicenseModal.youHaveInYourAccount' | i18next: { money:
          balanceValue | pricePrepayment | async
      } }}</span>
      <span class="d-block mt-2">{{ 'shared:licenses.renewLicenseModal.theCostOfRenewalIs' | i18next: { money:
          getTotalDiff() | pricePrepayment | async}
        }}</span>
    </ng-container>

    <ng-container *ngIf="!isNotEnoughCreditsToPay">
      <span class="d-block mt-2">{{ 'shared:licenses.renewLicenseModal.youHaveInYourAccount' | i18next: { money:
          balanceValue | pricePrepayment | async
      } }}</span>
      <span class="d-block mt-2">{{
          'shared:licenses.renewLicenseModal.theEntirePaymentWillBePaidInCredits' | i18next: { money: balanceValue | pricePrepayment | async}
        }}</span>
    </ng-container>

    <span class="d-block mt-2 mb-2"> {{
        'shared:licenses.renewLicenseModal.autoRenewalWillBeEnabledForThemAutomatically'
          | i18next }}</span>

    <h5>Licenses</h5>

    <mbs-renewal-table [licenses]="licensesInfo?.licenses"
                       [isProratedColumnShown]="true"></mbs-renewal-table>

    <div class="d-flex justify-content-between mt-3"
         *ngIf="licensesInfo?.listPrice">
      <div class="col-9">
        <ng-container *ngIf="minCommitment">The minimum {{ isYearlyLicenseMode ? 'yearly' : 'monthly' }} payment is
          <b>{{ minCommitment | pricePrepayment: null : null | async }}</b></ng-container>
      </div>
      <div class="col-3 pr-2">
        <div class="row justify-content-between mt-2"
             *ngIf="minCommitment && showMinCommitment">
          <div class="col-auto">Minimum fee</div>
          <div class="col-auto">{{ minCommitment | pricePrepayment | async}}</div>

        </div>
        <div class="row justify-content-between"
             [ngClass]="{ 'mt-3' : showMinCommitment }">
          <div class="col-auto">List Price</div>
          <div class="col-auto">{{ licensesInfo.listPrice | pricePrepayment | async}}
          </div>
        </div>
        <div class="row justify-content-between mt-2">
          <div class="col-auto">Prorated Price</div>
          <div class="col-auto">{{ licensesInfo.proratedPrice | pricePrepayment | async}}

            <i [ngbTooltip]="'licenses:prepayment:table:tooltips:prorated'| i18next"
               class="fa fa-question-circle text-gray-400 hint"
               container="body">
            </i>
          </div>

        </div>
        <div class="row justify-content-between mt-2">
          <div class="col-auto">Discount</div>
          <div class="col-auto">{{ licensesInfo.discount | pricePrepayment | async}}
          </div>
        </div>
        <div class="row justify-content-between mt-2"
             *ngIf="balanceValue">
          <div class="col-auto">Credits</div>
          <div class="col-auto">{{ balanceValue | pricePrepayment | async}}
          </div>
        </div>
        <div class="row justify-content-between mt-2">
          <div class="col-auto">
            <b>Total</b>
          </div>
          <div class="col-auto">
            <b>{{ total | pricePrepayment | async}}
              <i [ngbTooltip]="'shared:licenses.renewLicenseModal.minimumMonthlyFee' | i18next: { minCommitment: minCommitment | pricePrepayment: null : null | async, period: isYearlyLicenseMode ? 'yearly' : 'monthly' }"
                 class="fa fa-question-circle text-gray-400 hint"
                 container="body">
              </i>
            </b>
          </div>
        </div>
      </div>
    </div>

    <h5 class="mt-3"
        *ngIf="wasabiStoragesInfo?.length || awsStoragesInfo?.length">Storage</h5>

    <mbs-wasabi-table *ngIf="wasabiStoragesInfo?.length"
                      [licenses]="wasabiStoragesInfo"
                      [total]="wasabiStoragesTotalCost"></mbs-wasabi-table>

    <div class="mt-3"
         *ngIf="awsStoragesInfo?.length">
      <mbs-aws-table [licenses]="awsStoragesInfo"
                     [total]="awsStoragesTotalCost"></mbs-aws-table>
    </div>

  </div>
  <ng-container modalFooter>
    <mbs-button [loading]="renewLoading"
                (click)="renew()"
                type="primary">{{ 'shared:licenses.renewLicenseModal.submit' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button type="secondary"
                data-dismiss="modal"
                (click)="modal.close()">{{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
